<template>
  <div class="input-action-status">
    <div class="product-list">
      <OrderSummary noback noselect :input="input" @continue="done"></OrderSummary>
    </div>
  </div>
</template>

<script>
import {mapState} from 'vuex'
import OrderSummary from '@/components/OrderSummary'

export default {
  name: 'CheckoutConfirm',
  components: {
    OrderSummary
  },
  props: {
    input: Object
  },
  computed: {
    ...mapState(['session'])
  },
  methods: {
    done: function() {
      this.$emit('done')
      localStorage.removeItem('customer_support')
    },
    goBack: function() {
      this.$emit('back')
    }
  }
}
</script>

<style scoped>

</style>
